export const statusMessages = {
  ACTIVAR_CUENTA: 401,
  REGISTRAR_USUARIO: 400,
  RESTABLECER_CONTRASEÑA: 200,
  CEDULA_VENCIDA_NO_VIGENTE: -410,
  VALIDACION_IDENTIDAD_INCORRECTA: -401,
  CUENTA_BLOQUEADA: 410,
  ERROR_SERVICIO: -500,
};

export const cedulaNoVigente = {
  MENSAJE_CEDULA_NO_VIGENTE: `Es posible que tu Cédula de Identidad se encuentre bloqueada o vencida de acuerdo al Registro Civil. Si lo  requieres, revisa tu situación`,
  MENSAJE_CEDULA_NO_VIGENTE_NUEVO: `Intente más tarde`,
  MENSAJE_VALIDACION_IDENTIDAD_INCORRECTA:
    "Revisa tus datos y vuelve a intentar",
  registroCivilURL:
    "https://www.registrocivil.cl/principal/servicios-en-linea/consulta-vigencia-documento-1",
};

export const validacionUsuarioFlujos = {
  restablecerContraseñaSinValidacion: 1,
  restablecerContraseñaConValidacion: 2,
};

export const MENSAJE_AYUDA_CEDULA_NO_VIGENTE =
  "Ante dudas, contáctanos a ejecutivoachs@achs.cl";
